import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import API from "../api/axios";
import "../styles/auth.css";

const styles = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
`;

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  const handleLogin = async () => {
    if (!email || !password) { toast.error("Please fill in all fields"); return; }
    try {
      setLoading(true);
      const res = await API.post("/auth/login", { email, password });

      // Always persist to localStorage — session lasts until explicit logout
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      toast.success("Welcome to VaultSphere!");

      if (res.data.user.role === "ceo") {
        window.location.href = "https://vaultsphere-admin.vercel.app";
      } else {
        // Only ask language on very first login ever
        const lang = localStorage.getItem("language");
        navigate(lang ? "/dashboard" : "/select-language");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="vs-auth-page">
      <div className="vs-auth-card">
        <h1 className="vs-auth-logo">VaultSphere</h1>
        <p className="vs-auth-tagline">{t("loginTagline")}</p>
        <div className="vs-auth-divider">
          <div className="vs-auth-divider-line" /><div className="vs-auth-divider-dot" /><div className="vs-auth-divider-line" />
        </div>
        <div className="vs-auth-fields">
          <input className="vs-auth-input" type="email" placeholder={t("email")} value={email} onChange={e => setEmail(e.target.value)} onKeyPress={e => e.key === "Enter" && handleLogin()} />
          <input className="vs-auth-input" type="password" placeholder={t("password")} value={password} onChange={e => setPassword(e.target.value)} onKeyPress={e => e.key === "Enter" && handleLogin()} />
        </div>
        <div className="vs-auth-row">
          <Link to="/forgot-password" className="vs-auth-link">{t("forgotPasswordLink")}</Link>
        </div>
        <button className="vs-auth-btn" onClick={handleLogin} disabled={loading}>
          {loading ? t("signingIn") : t("loginButton")}
        </button>
        <p className="vs-auth-footer">{t("noAccount")} <Link to="/register">{t("registerHere")}</Link></p>
      </div>
    </div>
  );
}

export default Login;